const initialState = {
  isUploadInProgress: false,
  selectedFile: null,
  error: null,
};

export default initialState;
